<div class="dialog">
  <button class="dialog-close" type="button" mat-mini-fab color="primary" (click)="close(null)">
    <mat-icon>close</mat-icon>
  </button>
  <div fxLayout="column" fxLayoutGap="16px">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div class="mat-headline">
        <span>Rechten overnemen voor {{ editingUser?.Name }}</span>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
        <button (click)="save()" mat-raised-button color="primary">Opslaan</button>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
      <mat-form-field fxFlex="100%">
        <mat-label>Gebruiker *</mat-label>
        <mat-select [(value)]="selectedUser">
          <mat-option *ngFor="let option of users" [value]="option">{{ option.Name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>
